.container {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  width: 100%;
  background: var(--color-grayscale-tuna);
  border-radius: 0.4rem;

  @media screen and (min-width: $bp-medium) {
    height: 100%;
    padding: 1.6rem 2.4rem;
  }
}

.header {
  display: flex;
  justify-content: space-between;
  padding-bottom: 1.2rem;
  border-bottom: 0.1rem solid var(--color-grayscale-trout);
}

.title {
  width: 100%;
  font-size: 2rem;
  font-weight: 500;
  line-height: 2.4rem;
  text-align: center;
  color: var(--color-grayscale-white);
}

.info-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.8rem;
  height: 100%;
  padding: 1.6rem 0 0;
  margin: 0.4rem 1.6rem 0;
  border-top: solid 0.1rem var(--color-grayscale-trout);

  @media screen and (max-width: #{$bp-medium + 1}) {
    & > *:first-child {
      padding-inline-end: 0.8rem;
    }
  }

  @media screen and (min-width: $bp-medium) {
    gap: 2.4rem;
    padding: unset;
    margin: unset;
    border-top: unset;
  }
}

.address-field {
  all: unset;
  display: flex;
  flex-direction: row;
  gap: 0.8rem;
  align-items: center;
  height: fit-content;

  & > svg {
    min-width: fit-content;
    width: auto;

    &:first-child {
      align-self: flex-start;
    }
  }

  @media screen and (min-width: $bp-medium) {
    gap: 1.2rem;
  }
}

.field-container {
  border-inline-end: 0.1rem solid var(--color-grayscale-trout);
  height: fit-content;
  min-height: 4.8rem;

  @media screen and (min-width: $bp-medium) {
    height: 100%;
  }
}

.text {
  font-weight: 400;
  font-size: 1.2rem;
  line-height: 1.6rem;
  color: var(--color-grayscale-white);
}

.invisible {
  min-width: 3.2rem;
  width: 3.2rem;
  visibility: hidden;
}

.actions-container {
  margin: 0 1.6rem 0.8rem;
}
